<!-- </div> -->
<!-- content -->
                
<nav class="mobile-footer-menu">
	<ul>
		<li>
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/market-analysis',userData?.id] : ['/guest/dashboard']"><img class="icon-sports" src="assets/img/analysis.svg" />Market Analysis</a>
		</li>
		<li>
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/inplay'] : ['/guest/inplay']"><img class="icon-inplay" src="assets/img/timer.svg" />In-Play</a>
		</li>
		<li class="main-nav">
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" routerLink="/dashboard"><img class="icon-home" src="assets/img/home.svg" />Home</a>
		</li>
		<li>
			<!-- <a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/casino'] : ['/guest/casino']"><img class="icon-pin" src="assets/img/playing-cards.svg" />Casino</a> -->
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/multi-market'] : ['/login']"><img class="icon-pin" src="assets/img/pin-white-footer.svg" />Multi Market</a>
		</li>
		<li *ngIf="_common.getToken()">
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" routerLink="/mobile-menu"><img class="icon-account" src="assets/img/user.svg" />Account</a>
		</li>
		<li *ngIf="!_common.getToken()">
			<a class="ui-link" routerLinkActive="active" href="javascript:void(0)" (click)="openLogin()"><img class="icon-account" src="assets/img/user.svg" />Account</a>
		</li>
	</ul>
</nav>

<!-- Footer Start -->
<!-- <footer class="footer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-6">
				<script>document.write(new Date().getFullYear())</script> &copy; UBold theme by <a href="">Coderthemes</a> 
			</div>
			<div class="col-md-6">
				<div class="text-md-end footer-links d-none d-sm-block">
					<a href="javascript:void(0);">About Us</a>
					<a href="javascript:void(0);">Help</a>
					<a href="javascript:void(0);">Contact Us</a>
				</div>
			</div>
		</div>
	</div>
</footer> -->
<!-- end Footer -->

<!-- </div> -->

<!-- ============================================================== -->
<!-- End Page content -->
<!-- ============================================================== -->



